import {
  Button, Form,
} from 'antd';
import SelectInput from '../inputs/SelectInput';
import translations from '../../hooks/translation/translations.json';
import TextInput from '../inputs/TextInput';

const roleOptions = [
  { label: 'ადმინისტრატორი', value: 'admin' },
  { label: 'მარკეტინგი', value: 'marketing' },
];

function UsersForm({ errors, onFinish, form }) {
  return (
    <Form layout="vertical" form={form} onFinish={onFinish}>
      <TextInput
        label={`${translations.ka.email}*`}
        errorMessage={errors?.email}
        name="email"
      />
      <TextInput
        label={`${translations.ka.username}*`}
        errorMessage={errors?.username}
        name="username"
      />
      <TextInput
        label={`${translations.ka.password}*`}
        errorMessage={errors?.password}
        name="password"
      />
      <SelectInput
        name="role"
        label={`${translations.ka.role}*`}
        options={roleOptions}
        errorMessage={errors?.role}
      />
      <Form.Item>
        <Button type="primary" htmlType="submit">
          {translations.ka.submit}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default UsersForm;
